var map = {
	"./american-football.svg": 79112,
	"./australian-football.svg": 43247,
	"./badminton.svg": 54891,
	"./baseball.svg": 80485,
	"./basketball.svg": 76903,
	"./cricket.svg": 83251,
	"./custom.svg": 94606,
	"./cycling.svg": 88256,
	"./fighting.svg": 76374,
	"./football.svg": 46304,
	"./gaa.svg": 27769,
	"./handball.svg": 61184,
	"./hockey.svg": 61239,
	"./horseracing.svg": 6038,
	"./other.svg": 41831,
	"./racing.svg": 57334,
	"./rugby-australian-football.svg": 23814,
	"./rugby.svg": 1190,
	"./tennis.svg": 96567,
	"./volleyball.svg": 49183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40113;